import { message } from 'antd';

/**
 * Show one toast for a failed API call. The axios interceptor already shows
 * the server's message for most failures (and flags `error.toastShown`), so
 * this only speaks up when nothing has been shown yet.
 */
export const showApiError = (error, fallback = 'Something went wrong') => {
  if (error?.toastShown) return;
  message.error(error?.response?.data?.message || fallback);
};

export default showApiError;
